import NiceModal from "@ebay/nice-modal-react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

type Modal_type = {
  children?: any;
  isView: boolean;
  doAction?: () => void;
  cancelAction: () => void;
  deleteAction?: () => void;
  title: string;
  doActionText?: string;
  deleteText?: string;
};

const Modal = (props: Modal_type) => {
  const {
    children,
    isView,
    title,
    doAction,
    cancelAction,
    doActionText,
    deleteAction,
    deleteText,
  } = props;

  return (
    <Dialog onClose={cancelAction} open={isView}>
      <DialogTitle sx={{ lineHeight: "32px" }}>
        {title}
        <button
          type="button"
          className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center  float-right"
          data-modal-hide="defaultModal"
          onClick={() => cancelAction()}
        >
          <svg
            className="w-3 h-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
          <span className="sr-only">Close modal</span>
        </button>
      </DialogTitle>

      <DialogContent>{children}</DialogContent>

      <DialogActions>
        {doAction && (
          <div className="flex items-center p-6 space-x-2 border-t border-gray-200 rounded-b justify-center">
            {doAction && (
              <button
                onClick={() => doAction()}
                data-modal-hide="defaultModal"
                type="button"
                className="w-52 text-white bg-blue-500 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              >
                {`${doActionText ? doActionText : `확인`}`}
              </button>
            )}
            {deleteAction && (
              <button
                onClick={() => {
                  NiceModal.show("confirm", {
                    title: "정말로 삭제하시겠습니까?",
                    message: "이 동작은 되돌릴 수 없습니다.",
                  }).then(() => deleteAction());
                }}
                data-modal-hide="defaultModal"
                type="button"
                className="w-52 text-white bg-red-500 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
              >
                {`${deleteText ? deleteText : `삭제`}`}
              </button>
            )}

            <button
              onClick={() => cancelAction()}
              data-modal-hide="defaultModal"
              type="button"
              className="w-52 text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10"
            >
              {"취소"}
            </button>
          </div>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default Modal;
